import { PublicClientApplication, EventType, AuthenticationResult, Configuration, NavigationClient, NavigationOptions } from '@azure/msal-browser';
import * as H from 'history';

export const config = {
    appId: process.env.REACT_APP_AZURE_ID ?? '',
    authority: process.env.REACT_APP_AZURE_AUTHORITY ?? '',
    scopes: {
        api: `${process.env.REACT_APP_AZURE_APP_ID_URI}/user_impersonation`,
        user: 'User.Read'
    }
};

const msalConfig: Configuration = {
    auth: {
        clientId: config.appId,
        authority: config.authority,
        redirectUri: `${window.location.protocol}//${window.location.host}/api/auth/reply`
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false
    },
};
export class CustomNavigationClient extends NavigationClient {
    private history: H.History<H.LocationState>;

    constructor(history: H.History<H.LocationState>) {
        super();
        this.history = history // Passed in from useHistory hook provided by react-router-dom;
    }

    // This function will be called anytime msal needs to navigate from one page in your application to another
    async navigateInternal(url: string, options: NavigationOptions) {
        // url will be absolute, you will need to parse out the relative path to provide to the history API
        const relativePath = url.replace(window.location.origin, '');
        if (options.noHistory) {
            this.history.replace(relativePath);
        } else {
            this.history.push(relativePath);
        }

        return false;
    }
}

export interface AADUser {
    "@odata.context": string;
    businessPhones: [];
    displayName: string;
    givenName: string;
    id: string;
    jobTitle: string;
    mail: string;
    mobilePhone: string;
    officeLocation: string;
    preferredLanguage: string;
    surname: string;
    userPrincipalName: string;
}

export interface AuthState {
    error: any;
    isAuthenticated: boolean;
    user?: AADUser;
}


export const msalInstance = new PublicClientApplication(msalConfig);
const redirectPromise = msalInstance.handleRedirectPromise().catch((e: Error) => console.error(e));
export var currentToken = '';
msalInstance.addEventCallback((message: any) => {
    if (message.eventType === EventType.ACQUIRE_TOKEN_SUCCESS || message.eventType === EventType.LOGIN_SUCCESS || message.eventType === EventType.SSO_SILENT_SUCCESS) {
        const result = message.payload as AuthenticationResult;
        currentToken = result.accessToken;
    }
    //debugger;
    //if (message.eventType === EventType.LOGIN_FAILURE || message.eventType === EventType.SSO_SILENT_FAILURE)
    //debugger;
});

export const login = async (redirectPath: string) => {
    try {
        return await msalInstance.loginRedirect(
            {
                scopes: [config.scopes.user],
                prompt: "select_account",
                redirectStartPage: redirectPath
            });
    }
    catch {
        debugger;
        return await msalInstance.acquireTokenRedirect({
            scopes: [config.scopes.user],
            prompt: "select_account",
            redirectStartPage: redirectPath
        });
    }
}

export const logout = async () => {
    await msalInstance.logoutRedirect({
        postLogoutRedirectUri: process.env.REACT_APP_AZURE_ROOT_URI
    });
}

export const getDefaultAccessToken = async (): Promise<string> => {
    return await getAccessToken([config.scopes.api]);
}

export const getAccessToken = async (scopes: string[]): Promise<string> => {
    try {
        await redirectPromise;
        const accounts = msalInstance
            .getAllAccounts();

        if (accounts.length <= 0) throw new Error('login_required');

        var silentResult = await msalInstance
            .acquireTokenSilent({
                scopes: scopes,
                account: accounts[0],
                forceRefresh: true
            });

        return silentResult.accessToken;
    } catch (err: any) {
        console.log("GetAccessToken Error:", err)
        //debugger;
        if (isInteractionRequired(err)) {
            await msalInstance
                .acquireTokenRedirect({
                    scopes: scopes
                });

            return "";
        } else {
            clearSession();
            throw err;
        }
    }
}

export const normalizeError = (error: string | Error): any => {
    var normalizedError = {};
    if (typeof (error) === 'string') {
        var errParts = error.split('|');
        normalizedError = errParts.length > 1 ?
            { message: errParts[1], debug: errParts[0] } :
            { message: error };
    } else {
        normalizedError = {
            message: error.message,
            debug: JSON.stringify(error)
        };
    }
    return normalizedError;
}

export const getAllAccounts = () => {
    return msalInstance.getAllAccounts();
}

const isInteractionRequired = (error: Error): boolean => {
    if (!error.message || error.message.length <= 0) {
        return false;
    }

    return (
        error.message.indexOf('consent_required') > -1 ||
        error.message.indexOf('interaction_required') > -1 ||
        error.message.indexOf('login_required') > -1 ||
        error.message.indexOf('no_account_in_silent_request') > -1
    );
}

export const clearSession = () => {
    sessionStorage.clear();
    localStorage.clear();
}